// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  name: 'aera-prod',
  version: 'Error: no tags found (local or remote).',
  production: false,
  bucketName: 'aera',
  databaseUrl: { supabase: 'https://delktneundhfcysylzis.supabase.co', middleware: '' },
  posCloud: {
    apiURL: 'https://aera.menucat.de/api',
  },
  editEnabled: 'true',
  defaultLanguage: 'de',
  databaseAnonKey: { supabase: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRlbGt0bmV1bmRoZmN5c3lsemlzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM5NDcwNDEsImV4cCI6MjA4OTUyMzA0MX0.0E8_eZtlVs5vxJeJcxz6Hmbl_KVp-9puPvsrw64IclQ', middleware: '' },
  sentryDSN: '',
  posthogKey: 'phc_m3dOImc0jDJ5IzfKERikqSr4Nshq8XFVWV6DJKgYzhu',
  posthogHost: 'https://eu.i.posthog.com',
  posthogProxyHost: 'https://t.unauorder.com',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
